// parkUtils.js
export const HIDDEN_PARKS = {
  names: ['Columbus'], // Add names of parks to hide
};

export const filterHiddenParks = (parks) => {
  if (!parks) return [];
  return parks.filter(park => !HIDDEN_PARKS.names.includes(park.name));
};
